export default () => ({
  postal_codes: [],
});
